import { Axios } from "@/plugins";
import {
  CREATE_PROJECT,
  DELETE_PROJECT,
  PROJECTS,
  UPDATE_PROJECT,
  NETWORK_ERROR,
} from "@/api/endpoints";

export default {
  /*
   * Get projects
   */
  getProject: (params) => {

    return Axios.get("/project", {
      params: {
        ...params,
      },
    });
  },

  getAccessProject: (params) => {

    return Axios.get(`/project/${params.project_name}/user`);
  },

  /*
   * Update project
   * projectName = Existed project name
   * updateProjectName = new name for existed project
   */
  editProject: (payload) => {
    const { projectName} = payload;
    return Axios.put(`/projects/${projectName}`, {
      data: {
        ...payload
      },
    });
  },
  /*
   * Create project
   * projectName = Existed project name
   * updateProjectName = new name for existed project
   */
  createProject: (payload) => {
    return Axios.post("/project", {
    
        ...payload,
      
    });
  },

  inviteUser: (payload) => {
    return Axios.post(`/project/${payload.projectName}/user`, {
    
        email:payload.email
      
    });
  },
  accessProjectInvite: (payload) => {
    return Axios.post(`/project/invite/${payload.invite_id}/accept`);
  },
  getInviteDetails: (params) => {

    return Axios.get(`/project/invite/${payload.invite_id}`);
  },
  /*
   * Delete project
   */
  deleteProject: (payload) => {
    const { projectName } = payload;
    return Axios.delete(`/projects/${projectName}`);
  },
};

export const fetchProjects = async (token) => {
  try {

    const response = await Axios.get(PROJECTS, {
      headers: { Authorization: `Bearer ${token}` },
      validateStatus: () => true,
    });
    return response;
  } catch (error) {
    return NETWORK_ERROR;
  }
};

export const createNew = async (token, project) => {
  try {
    const response = await Axios.post(
      CREATE_PROJECT,
      { project },
      {
        headers: { Authorization: `Bearer ${token}` },
        validateStatus: () => true,
      }
    );
    return response;
  } catch (error) {
    return NETWORK_ERROR;
  }
};

export const removeProject = async (token, projectId) => {
  try {
    const response = await Axios.post(
      DELETE_PROJECT,
      { projectId },
      {
        headers: { Authorization: `Bearer ${token}` },
        validateStatus: () => true,
      }
    );
    return response;
  } catch (error) {
    return NETWORK_ERROR;
  }
};

export const updateProject = async (token, newProjectData) => {
  try {
    const response = await Axios.post(
      UPDATE_PROJECT,
      { newProjectData },
      {
        headers: { Authorization: `Bearer ${token}` },
        validateStatus: () => true,
      }
    );

    return response;
  } catch (error) {
    return NETWORK_ERROR;
  }
};
